/* eslint-disable no-param-reassign */
import React from "react";
import { Button, Row, DatePicker, Input, Select, Col, Form, message } from "antd";
import "../../styles/filters-form.less";
import "./ServiceProfileCreateForm.less";
import { useDispatch, useSelector } from "react-redux";
import moment from "moment";
import { useHistory } from "react-router-dom";
import {
  displayFormat,
  infinityDateHttpFormat,
  toHttpFormat,
  toHttpFormatStartOfDay,
} from "../../lib/utils/formatDate";
import { createProfilesVersion, fetchServiceProfiles } from "../../store/slices/service-profile";
import { buildQueryStringWithObjectParams } from "../../lib/utils";
import LocalStorageService from "../../services/LocalStorageService";
import RequiredMark from "../common/RequiredMark/RequiredMark";

const ServiceProfileCreateForm = () => {
  const dateFormat = displayFormat;
  const [form] = Form.useForm();
  const dispatch = useDispatch();
  const { Option } = Select;
  const history = useHistory();
  const dateNow = toHttpFormatStartOfDay(moment());
  const dateEndForCreate = moment(infinityDateHttpFormat);

  const serviceProfilesParams = {
    onDate: dateNow,
    profileType: "common",
  };

  const { serviceProfiles } = useSelector((state) => state.serviceProfile);

  const queryStringServiceProfiles = `&${buildQueryStringWithObjectParams(serviceProfilesParams)}`;

  const { invoicePeriodStatus, prePaymentPeriodStatus, paymentTypeStatus } = useSelector(
    (state) => state.rtkDictionaries
  );

  const validateMessages = {
    required: "",
  };

  const onFinish = async (values) => {
    if (values) {
      values.tenantId = Number(LocalStorageService.getTenantId());
      values.dsc = "";
      values.profileTypeId = 1;
      values.billPeriodId = values.invoicePeriodId;
      values.prepaymentToPayDays = Number(values.prepaymentToPayDays);
      values.billToPayDays = Number(values.billToPayDays);
      values.fromDate = toHttpFormatStartOfDay(values.fromDate);
      values.toDate = toHttpFormat(values.toDate);
    }

    const findIndex =
      serviceProfiles &&
      serviceProfiles.findIndex((item) => String(item.name) === String(values.name));

    if (findIndex === -1) {
      await dispatch(createProfilesVersion(values));
      history.push(`/service-profile`);

      dispatch(fetchServiceProfiles({ queryString: queryStringServiceProfiles }));
    } else {
      message.warning("Профиль с таким наименованием уже существует");
    }
  };

  return (
    <div className="inner-row">
      <h1>Новый профиль оплаты</h1>
      <Row>
        <Form
          style={{ width: "100%" }}
          form={form}
          validateMessages={validateMessages}
          name="advanced_search"
          initialValues={{
            prepaymentBeforeDays: 30,
            toDate: dateEndForCreate,
          }}
          className="profile-search-create-form"
          onFinish={onFinish}
        >
          <Row className="profile-search-create-form__row-label" align="middle">
            <Col span={4}>
              <RequiredMark>
                <label>Наименование</label>
              </RequiredMark>
            </Col>
            <Col span={2}>
              <RequiredMark>
                <label>Тип оплаты</label>
              </RequiredMark>
            </Col>
            <Col span={2}>
              <RequiredMark>
                <label>Расчётный период</label>
              </RequiredMark>
            </Col>
            <Col span={2}>
              <RequiredMark>
                <label>Периодичность счёта</label>
              </RequiredMark>
            </Col>
            <Col span={2}>
              <RequiredMark>
                <label>Срок оплаты счёта на предоплату</label>
              </RequiredMark>
            </Col>
            <Col span={2}>
              <label>Выставлять счёт на предоплату за</label>
            </Col>
            <Col span={2}>
              <RequiredMark>
                <label>Срок оплаты счета на постоплату</label>
              </RequiredMark>
            </Col>
            <Col span={2}>
              <RequiredMark>
                <label>Период действия c</label>
              </RequiredMark>
            </Col>
            <Col span={2}>
              <label>Период действия по</label>
            </Col>
          </Row>

          <Row
            className="profile-search-create-form__row-content"
            style={{ marginTop: "20px", marginBottom: "100px" }}
            align="top"
          >
            <Col span={4}>
              <Form.Item
                className="profile-search-create-form__col form-item-required__hidden-error__mb0"
                name="name"
                rules={[
                  {
                    required: true,
                  },
                ]}
              >
                <Input />
              </Form.Item>
            </Col>

            <Col span={2}>
              <Form.Item
                className="profile-search-create-form__col form-item-required__hidden-error__mb0"
                name="paymentTypeId"
                rules={[
                  {
                    required: true,
                  },
                ]}
              >
                <Select style={{ minWidth: "100px" }}>
                  {paymentTypeStatus &&
                    paymentTypeStatus.map((item) => (
                      <Option key={item.id} value={item.id}>
                        {item.name}
                      </Option>
                    ))}
                </Select>
              </Form.Item>
            </Col>

            <Col span={2}>
              <Form.Item
                className="profile-search-create-form__col form-item-required__hidden-error__mb0"
                name="invoicePeriodId"
                rules={[
                  {
                    required: true,
                  },
                ]}
              >
                <Select style={{ minWidth: "100px" }}>
                  {invoicePeriodStatus &&
                    invoicePeriodStatus.map((item) => (
                      <Option key={item.id} value={item.id}>
                        {item.name}
                      </Option>
                    ))}
                </Select>
              </Form.Item>
            </Col>

            <Col span={2}>
              <Form.Item
                className="profile-search-create-form__col form-item-required__hidden-error__mb0"
                name="prepaymentPeriodId"
                rules={[
                  {
                    required: true,
                  },
                ]}
              >
                <Select style={{ minWidth: "100px" }}>
                  {prePaymentPeriodStatus &&
                    prePaymentPeriodStatus.map((item) => (
                      <Option key={item.id} value={item.id}>
                        {item.name}
                      </Option>
                    ))}
                </Select>
              </Form.Item>
            </Col>

            <Col span={2}>
              <Form.Item
                className="profile-search-create-form__col form-item-required__hidden-error__mb0"
                name="prepaymentToPayDays"
                rules={[
                  {
                    required: true,
                  },
                  {
                    pattern: /^(|[1-9][0-9]*)$/,
                    message: "",
                  },
                ]}
              >
                <Input placeholder="Введите число > 0" maxLength={5} />
              </Form.Item>
            </Col>

            <Col span={2}>
              <Form.Item
                className="profile-search-create-form__col form-item-required__hidden-error__mb0"
                name="prepaymentBeforeDays"
                rules={[
                  {
                    required: true,
                  },
                  {
                    pattern: /^(|[1-9][0-9]*)$/,
                    message: "",
                  },
                ]}
              >
                <Input placeholder="Введите число > 0" maxLength={5} />
              </Form.Item>
            </Col>

            <Col span={2}>
              <Form.Item
                className="profile-search-create-form__col form-item-required__hidden-error__mb0"
                name="billToPayDays"
                rules={[
                  {
                    required: true,
                  },
                  {
                    pattern: /^(|[1-9][0-9]*)$/,
                    message: "",
                  },
                ]}
              >
                <Input placeholder="Введите число > 0" maxLength={5} />
              </Form.Item>
            </Col>

            <Col span={2}>
              <Form.Item
                className="profile-search-create-form__col form-item-required__hidden-error__mb0"
                name="fromDate"
                rules={[
                  {
                    required: true,
                  },
                ]}
              >
                <DatePicker format={dateFormat} allowClear={false} />
              </Form.Item>
            </Col>

            <Col span={2}>
              <Form.Item
                className="profile-search-create-form__col form-item-required__hidden-error__mb0"
                name="toDate"
              >
                <DatePicker disabled format={dateFormat} allowClear={false} />
              </Form.Item>
            </Col>
          </Row>

          <Row
            align="middle"
            style={{ borderTop: "1px solid #CCDDEE", paddingTop: "10px" }}
            justify="center"
          >
            <Col
              span={24}
              style={{
                textAlign: "center",
              }}
            >
              <Button
                style={{
                  margin: "0 8px",
                }}
                onClick={() => {
                  form.resetFields();
                  history.push(`/service-profile`);
                }}
              >
                Отмена
              </Button>
              <Button type="primary" htmlType="submit">
                Сохранить
              </Button>
            </Col>
          </Row>
        </Form>
      </Row>
    </div>
  );
};

export default ServiceProfileCreateForm;
